<p-card [header]="texts.titulo" [style]="{ width: '100%' }" *ngIf="pessoaId">
    <div class="customer-card">
        <div class="customer-header">
            <img src="https://via.placeholder.com/50" alt="Profile" class="profile-img" />
            <span class="customer-name">{{pessoa.nome}}</span>
        </div>
        <hr />
        <div class="customer-info">
            <div class="info-item" *ngIf="IsFornecedor">
                <i class="pi pi-shopping-cart icon"></i>
                <span>{{texts.quantidade_vendas}}: {{pessoaValores.quantidadeVendas}} </span>
            </div>
            <div class="info-item text" *ngIf="IsFornecedor">
                <i class="pi pi-wallet icon"></i>
                <span>{{texts.total_vendas}}: {{pessoaValores.totalVendas ? pessoaValores.totalVendas : 0}} $</span>
            </div>
            <div class="info-item">
                <i class="pi pi-shopping-cart icon"></i>
                <span>{{texts.quantidade_compras}}: {{pessoaValores.quantidadeCompras}} </span>
            </div>
            <div class="info-item text">
                <i class="pi pi-wallet icon"></i>
                <span>{{texts.total_compras}}: {{pessoaValores.totalCompras ? pessoaValores.totalCompras : 0}} $</span>
            </div>
        </div>
        <hr />
        <div class="contact-info">
            <strong>{{texts.informacoes_contato}}</strong>
            <div class="text">
                <i class="pi pi-phone icon"></i> {{pessoa.telefone}}
            </div>
            <div class="text">
                <i class="pi pi-envelope icon"></i> {{pessoa.email}}
            </div>
        </div>
        <hr />
        <div class="address-info">
            <strong>{{texts.endereco}}</strong>
            <div class="text">{{texts.estado}}: {{pessoa.estadoNome}}</div>
            <div class="text">{{texts.cidade}}: {{pessoa.cidadeNome}}</div>
            <div class="text">{{texts.endereco}}: {{pessoa.endereco}}</div>
        </div>
    </div>
</p-card>
